module.exports = __webpack_public_path__ + "img/icon_quick_facebook.39e4cfc3.svg";